import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreatePromocodeMutation } from "@modules/promocodes/services/mutations";
import { PromocodeFormValues, promocodeSchema } from "@modules/promocodes/validations";
import { listPromocodesQueryKey } from "@modules/promocodes/services/queries/listPromocodes/query";
import { CreatePromocodeModalProps } from "./types";

export function useCreatePromocodeModal({ modalRef, onComplete }: CreatePromocodeModalProps) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<PromocodeFormValues>({
    resolver: zodResolver(promocodeSchema()),
    defaultValues: {
      valid_until: new Date().toDateString(),
      active: true,
    },
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreatePromocodeMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listPromocodesQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("promocode_admin.success.create"),
      });

      onComplete(); 
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
